export default __webpack_public_path__ + "src/images/title-7cf2e5.png";